/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Airline
 */
export interface Airline {
    /**
     * URL to the airline's conditions of carriage.
     * @type {string}
     * @memberof Airline
     */
    conditionsOfCarriageUrl?: string | null;
    /**
     * The two-character IATA code for the airline. This may be `null` for non-IATA carriers.
     * @type {string}
     * @memberof Airline
     */
    iataCode?: string | null;
    /**
     * Duffel's unique identifier for the airline
     * @type {string}
     * @memberof Airline
     */
    id?: string;
    /**
     * Path to a svg of the airline lockup logo.
     * A lockup logo is also called a combination logo, in which it combines the logotype and logomark.
     * This may be `null` if no logo is available.
     * @type {string}
     * @memberof Airline
     */
    logoLockupUrl?: string | null;
    /**
     * Path to a svg of the airline logo.
     * This may be `null` if no logo is available.
     * @type {string}
     * @memberof Airline
     */
    logoSymbolUrl?: string | null;
    /**
     * The name of the airline
     * @type {string}
     * @memberof Airline
     */
    name?: string;
}

/**
 * Check if a given object implements the Airline interface.
 */
export function instanceOfAirline(value: object): value is Airline {
    return true;
}

export function AirlineFromJSON(json: any): Airline {
    return AirlineFromJSONTyped(json, false);
}

export function AirlineFromJSONTyped(json: any, ignoreDiscriminator: boolean): Airline {
    if (json == null) {
        return json;
    }
    return {
        
        'conditionsOfCarriageUrl': json['conditions_of_carriage_url'] == null ? undefined : json['conditions_of_carriage_url'],
        'iataCode': json['iata_code'] == null ? undefined : json['iata_code'],
        'id': json['id'] == null ? undefined : json['id'],
        'logoLockupUrl': json['logo_lockup_url'] == null ? undefined : json['logo_lockup_url'],
        'logoSymbolUrl': json['logo_symbol_url'] == null ? undefined : json['logo_symbol_url'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AirlineToJSON(json: any): Airline {
    return AirlineToJSONTyped(json, false);
}

export function AirlineToJSONTyped(value?: Airline | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conditions_of_carriage_url': value['conditionsOfCarriageUrl'],
        'iata_code': value['iataCode'],
        'id': value['id'],
        'logo_lockup_url': value['logoLockupUrl'],
        'logo_symbol_url': value['logoSymbolUrl'],
        'name': value['name'],
    };
}

